<script>
import hooksMixin from '@/v-shop/mixins/hooks-mixin'

export default {
	mixins: [hooksMixin('Footer')],
	data() {
		return {
			dataTop: this.$srv('FooterTop', {}),
			dataBottom: this.$srv('FooterBottom', {}),
		}
	},
}
</script>

<template>
	<footer>
		<hook zone="top">
			<Footer-Top :data="dataTop" class="py-6" />
		</hook>
		<Footer-Bottom :data="dataBottom" />
	</footer>
</template>

